import { useTranslations } from 'next-intl';

import { useBitcoinPrice } from '@/hooks/api/useBitcoinPrice';

export default function PriceFeedNotice() {
  const { priceStatus } = useBitcoinPrice();
  const t = useTranslations('layout.header');
  if (priceStatus !== 'unavailable') return null;
  return (
    <p
      role="status"
      className="mx-4 mt-4 rounded-lg border border-border-primary bg-surface-secondary px-4 py-3 text-sm text-text-secondary"
    >
      {t('priceUnavailable')}
    </p>
  );
}
